/**
 * @description 向url query中增加单个key=value
 * @param url url不传则取当前页面url
 * @param param 单个query的key
 * @param value 单个query的value
 * @returns 拼接后的url
 */
const addParam = (url: string, param: string, value: string): string => {
  if (!url) url = window.location.href;
  const re = new RegExp('([&\\?])' + param + '=[^& ]*', 'g');
  url = url.replace(re, function (_a, b) {
    return b == '?' ? '?' : '';
  });
  const idx = url.indexOf('?');
  const hashIndex = url.indexOf('#');
  if (hashIndex < 0) {
    url =
      (idx > -1 ? (idx + 1 != url.length ? url + '&' : url + '') : url + '?') + param + '=' + value;
  }
  return url;
};

export default addParam;
